import React from 'react'

import { Table, Divider, Button, Row, Col } from '_zari/core'

import DocumentosSunatConstant from 'constants/tiposDeDocumentoSunat'

import { DateHandler } from 'utils'

import * as FormGroups from './formGroups'

const ListaDocumentosSection = ({ idSocio, clickSeleccionarDocumentoClick }) => {
  const fechaDesdeDefaultValue = React.useMemo(() => {
    const fechaNueva = DateHandler.substract(new Date(), {
      months: 6
    })

    const fechaString = DateHandler.format(fechaNueva)

    return fechaString
  }, [])

  const [fechaDesde, setFechaDesde] = React.useState(fechaDesdeDefaultValue)

  const tableRef = React.useRef(null)

  const clickConsultarDocumentosHandler = React.useCallback(() => {
    tableRef.current.reload({
      fechaDesde: fechaDesde
    })
  }, [fechaDesde])

  return (
    <>
      <Row>
        <Col md={6}>
          <FormGroups.FechaDesdeFormGroup value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
        </Col>
        <Col md={2}>
          <Button onClick={clickConsultarDocumentosHandler}>Consultar</Button>
        </Col>
      </Row>
      <Divider />
      <Table.ServerSide
        useNest={true}
        ref={tableRef}
        url='/facturaciones'
        baseParams={{
          tipoConsulta: 'slim',
          idSocio: idSocio,
          fechaDesde: fechaDesde
        }}
        headRows={[{ label: 'FECHA' }, { label: 'TIPO DOC.' }, { label: 'SERIE DOC.' }, { label: 'NUMERO DOC.' }, { label: '' }]}
        rowTemplate={row => (
          <Table.Row hover key={row._id}>
            <Table.Cell>{row.fechaEmision}</Table.Cell>
            <Table.Cell>{row.tipoDocumento ? DocumentosSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}</Table.Cell>
            <Table.Cell>{row.serieDocumento}</Table.Cell>
            <Table.Cell>{row.numeroDocumento}</Table.Cell>
            <Table.Cell>
              <Button onClick={e => clickSeleccionarDocumentoClick(row)}>Seleccionar</Button>
            </Table.Cell>
          </Table.Row>
        )}
      />
    </>
  )
}

export default ListaDocumentosSection
